import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class WidthLayoutService {
    private readonly _maxWidth$ = new BehaviorSubject<string>('none');
    readonly maxWidth$ = this._maxWidth$.asObservable().pipe(distinctUntilChanged());

    setMaxWidth(width: string) {
        if (this._maxWidth$.value !== width) this._maxWidth$.next(width);
    }
}
